import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Grid,
  Autocomplete,
  Checkbox,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import { NGROK } from "../../../APIs";
import { makeStyles } from "@mui/styles";
import styled from "styled-components";
import { myLocalStorage } from "../../../components/StorageHelper";
import { awsIcons } from "./AWSIcons";
import useUserStore from "../../../services/userStore";
import moment from "moment/moment";
import TailwindFilterHeader from "../../../tailwind-ui/components/TailwindFilterHeader";
import TailwindTable from "../../../tailwind-ui/components/TailwindTable";
import PolicyDetailsModal from "./components/PolicyDetailsModal";
import { triggerCloudSync } from "../../../triggerCloudSync";
import useCloudSyncStore from "../../../services/useCloudSyncStore";
import useNotificationStore from "../../../services/notificationStore";

const Wrapper = styled.div`
  max-height: 500px;
`;

const useStyles = makeStyles({
  root: {
    maxHeight: "500px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "10px",
    },
  },
});

const AWSGroups = () => {
  const classes = useStyles();

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [groupUsers, setGroupUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rolesDetailsModalOpen, setRolesDetailsModalOpen] = useState(false);
  const [rolesPermissionJson, setRolesPermissionJson] = useState([]);
  const [policiesDetailsModalOpen, setPoliciesDetailsModalOpen] =
    useState(false);
  const [policiesDetails, setPoliciesDetails] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedTenantName, setSelectedTenantName] = useState(null);
  const [tenantList, setTenantList] = useState([]);
  const userData = useUserStore((state) => state.user);
  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loadingPolicies, setLoadingPolicies] = useState({});
  const [isSyncing, setIsSyncing] = useState(false);
  const [syncError, setSyncError] = useState(null);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const syncStatus = useCloudSyncStore((state) => state.syncStatus);
  let { awsConfig } = useNotificationStore.getState();
  const [awsAccountId, setAWSAccountId] = useState("");
  const [accounts, setAccounts] = useState([]);
  const selectedAwsAccount = myLocalStorage.getItem("selectedAwsAccount");

  const handleUserSelect = (userName) => {
    setSelectedUsers(userName);
  };

  const handleDeleteMembership = async () => {
    const response = await axios.post(
      `${NGROK}/api/aws/removeUserGroup?tenantName=${latestTenant}&groupName=${selectedGroup.groupName}&accountId=${selectedAwsAccount}`,
      selectedUsers,
    );
    if (response) {
      ondemandButton();
    }
  };

  const handleUsersSearchChange = (event) => {
    const search = event.target.value;

    if (!search.trim()) {
      console.log(groupUsers);
      setFilteredUsers(groupUsers);
      return;
    }

    const filteredUsers = groupUsers.filter(
      (user) =>
        user.username &&
        user.username.toLowerCase().includes(search.toLowerCase()),
    );

    setFilteredUsers(filteredUsers);
  };

  const handleAccountChange = (value) => {
    const account = accounts.find((account) => account.value === value);
    if (account !== undefined) {
      setLoading(true);
      setSelectedGroup(null);
      setSelectedUser(null);
      setSelectedUsers([]);
      setFilteredUsers([]);
      setGroupUsers([]);
      setSearchTerm("");
      setGroups([]);
      setUsers([]);
      myLocalStorage.setItem("selectedAwsAccount", account.value);
      setAWSAccountId(account.value);
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setSelectedGroup(null);
    setSelectedUser(null);
    setSelectedUsers([]);
  };

  const handleGroupClick = (group) => {
    setSelectedGroup(group);
    setGroupUsers(group.users);
    setSelectedUser(null);
    setSelectedUsers([]);
  };

  const handleUserClick = (user) => {
    setSelectedUser(user);
    setTabValue("user");
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const filteredGroups = groups.filter((group) =>
    group.groupName.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const getAllGroups = async () => {
    const response = await axios.get(
      `${NGROK}/api/aws/getIamgroups?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`,
    );
    return response.data;
  };

  const getAllRoles = async () => {
    const response = await axios.get(
      `${NGROK}/api/aws/getIamroles?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`,
    );
    return response.data;
  };

  const ondemandButton = async () => {
    try {
      const data = await triggerCloudSync(
        "aws",
        "/api/aws/ondemand",
        latestTenant,
      );
    } catch (error) {
      setAlertSeverity("error");
      setSyncError(error?.response?.data?.message);
    }
    fetchData(false, true);
  };

  const combinedPermissionandGetRoles = (groups, roles) => {
    return groups.map((group) => {
      const items = [...group.groupPolicies, ...(group.userPolicies || [])];
      const matchingRoles = [];

      roles.forEach((role) => {
        role?.rolePolicies?.forEach((policy) => {
          if (items.includes(policy.policyArn)) {
            matchingRoles.push({
              roleName: role.roleName,
              roleId: role.roleId,
              roleArn: role.roleArn,
            });
          }
        });
      });

      group.roles = matchingRoles;

      return group;
    });
  };

  const fetchData = async (
    initialLoad = false,
    isDeletedMemberShip = false,
  ) => {
    const selectedAwsAccount = myLocalStorage.getItem("selectedAwsAccount");
    if (!selectedAwsAccount) {
      setLoading(false);
      return;
    }
    try {
      const [groupsData, rolesData] = await Promise.all([
        getAllGroups(),
        getAllRoles(),
      ]);

      let policiesConsolidation = combinedPermissionandGetRoles(
        groupsData,
        rolesData,
      );
      setGroups(groupsData);

      setLoading(false);
      if (initialLoad && groupsData.length > 0) {
        const group = groupsData[0];
        setSelectedGroup(group);
        setGroupUsers(group.users);
      } else if (isDeletedMemberShip) {
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setLoading(false);
    }
  };

  const handleViewButtonClick = async (policyARN) => {
    setLoadingPolicies((prev) => ({ ...prev, [policyARN]: true }));

    const policyDetails = await fetchPolicyDocDetails(policyARN);
    setLoadingPolicies((prev) => ({ ...prev, [policyARN]: false }));
    const policyDocumentString = policyDetails.policyDocument;
    const parsedPolicyDocument = JSON.parse(policyDocumentString);
    policyDetails.policyDocument = parsedPolicyDocument;
    console.log("Policy details:", policyDetails);
    setPoliciesDetails([policyDetails]);
    setPoliciesDetailsModalOpen(true);
  };

  const fetchPolicyDocDetails = async (policyArns) => {
    try {
      const response = await axios.get(
        `${NGROK}/api/aws/getSpecificIAMPolicydetails?tenantName=${latestTenant}&policyarn=${encodeURIComponent(policyArns)}&accountId=${selectedAwsAccount}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching policy details:", error);
      return null;
    }
  };

  const fetchAllAccounts = async () => {
    try {
      const response = await axios.get(
        `${NGROK}/api/aws/getAllAccounts?tenantName=${latestTenant}`,
      );

      if (response?.data) {
        const accounts = response.data.map((account) => ({
          label: account.accountName,
          value: account.accountId,
        }));

        setAccounts(accounts);

        const storedAccountId = myLocalStorage.getItem("selectedAwsAccount");
        const accountExists = accounts.find(
          (account) => account.value === storedAccountId,
        );

        if (storedAccountId && accountExists) {
          setAWSAccountId(storedAccountId);
        } else {
          const defaultAccountId = accounts[0]?.value || "";
          setAWSAccountId(defaultAccountId);
          myLocalStorage.setItem("selectedAwsAccount", defaultAccountId);
        }
      }
    } catch (error) {
      console.error("Error fetching AWS accounts", error);
    }
  };

  useEffect(() => {
    fetchData(true);
  }, [selectedAwsAccount]);

  useEffect(() => {
    fetchAllAccounts();
  }, [latestTenant]);

  useEffect(() => {
    if (selectedGroup) {
      setFilteredUsers(selectedGroup.users);
    }
  }, [selectedGroup]);

  const handleTenantChange = (value) => {
    const tenant = tenantList.find((tenant) => tenant.tenantName === value);
    if (tenant !== undefined) {
      setSelectedTenantName(tenant.tenantName);
      myLocalStorage.setItem("latestTenant", tenant);
    }
  };

  useEffect(() => {
    if (tenantList.length === 1)
      return setSelectedTenantName(tenantList[0].tenantName);

    if (tenantList?.length > 1) {
      const latestTenantName =
        myLocalStorage.getItem("latestTenant")?.tenantName;

      const tenant = tenantList.find(
        (tenant) => tenant.tenantName === latestTenantName,
      );
      if (tenant) setSelectedTenantName(tenant.tenantName);
      else setSelectedTenantName(tenantList[0].tenantName);
    }
  }, [tenantList]);

  useEffect(() => {
    const fetchTenants = async () => {
      const response = await axios.get(`${NGROK}/api/get-all-domains`);
      setTenantList(response.data);
    };
    fetchTenants();
  }, [userData]);
  const renderGroupListCell = (group, colIndex) => {
    switch (colIndex) {
      case 0:
        return (
          <div
            className="flex items-center justify-between py-2"
            onClick={() => handleGroupClick(group)}
          >
            <div className="ml-2">
              <p className="text-lg font-semibold">{group.groupName}</p>
            </div>
          </div>
        );

      default:
        return null;
    }
  };
  const renderUserName = (user, colIndex) => {
    switch (colIndex) {
      case 0:
        return (
          <div
            className={`flex items-center p-1 rounded-md transition-all duration-150`}
            onClick={() => handleUserClick(user)}
          >
            <Checkbox
              checked={selectedUsers == user.username}
              onChange={() => handleUserSelect(user.username)}
              className="mr-3"
            />
            <div className="flex items-center">
              <div className="text-xl">{awsIcons.user}</div>
              <div className="ml-3">
                <p className="text-lg font-semibold">{user.username}</p>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  const renderUserDetailsCell = (
    user,
    colIndex,
    col,
    tabValue,
    setTabValue,
    selectedGroup,
  ) => {
    const tabs = [
      { label: "User", value: "user" },
      { label: "Roles", value: "roles" },
      { label: "Permissions", value: "permissions" },
    ];

    const renderUserInfo = () => (
      <ul className="divide-y divide-gray-200">
        {[
          { label: "Username", value: user.username },
          { label: "User ID", value: user.userId },
          { label: "ARN", value: user.arn },
          {
            label: "Created At",
            value: user.createDate
              ? moment(user.createDate).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          },
        ].map(({ label, value }, index) => (
          <li key={index} className="px-4 py-3">
            <div className="text-base font-semibold text-gray-700">{label}</div>
            <div className="text-base text-gray-900 break-words">
              {value || "-"}
            </div>
          </li>
        ))}
      </ul>
    );

    const renderRoles = () =>
      selectedGroup?.roles?.length > 0 ? (
        <ul className="divide-y divide-gray-200">
          {selectedGroup.roles.map((role, index) => (
            <li key={index} className="px-4 py-3">
              <div className="text-base font-semibold text-gray-700">Role</div>
              <div className="text-base text-gray-900">{role.roleName}</div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="p-4 text-sm text-gray-500">No roles assigned</div>
      );

    const renderPermissions = () =>
      selectedGroup?.groupPolicies?.length > 0 ? (
        <ul className="divide-y divide-gray-200">
          {selectedGroup.groupPolicies.map((perm, index) => (
            <li key={index} className="px-4 py-3">
              <div className="mb-1 text-base font-semibold text-gray-700">
                Permission
              </div>
              <div className="flex items-center justify-between text-base text-gray-900">
                <span>{perm.policyARN?.split("/")?.[1] || perm.policyARN}</span>
                <button
                  onClick={() => handleViewButtonClick(perm.policyARN)}
                  disabled={loadingPolicies[perm.policyARN] || false}
                  className={`ml-4 px-4 py-2 text-sm font-medium text-white rounded ${
                    loadingPolicies[perm.policyARN]
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-600 hover:bg-blue-700"
                  }`}
                >
                  {loadingPolicies[perm.policyARN] ? "Loading..." : "View"}
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="p-4 text-sm text-gray-500">No permissions assigned</div>
      );

    switch (colIndex) {
      case 0:
        return (
          <div className="w-full">
            <div className="flex border-b border-gray-300">
              {tabs.map((tab) => (
                <button
                  key={tab.value}
                  onClick={() => setTabValue(tab.value)}
                  className={`text-lg font-semibold px-4 py-2 transition-colors duration-200 ${
                    tabValue === tab.value
                      ? "border-b-2 border-blue-600 text-blue-600"
                      : "text-gray-600 hover:text-blue-500"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div className="mt-2">
              {tabValue === "user" && renderUserInfo()}
              {tabValue === "roles" && renderRoles()}
              {tabValue === "permissions" && renderPermissions()}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {syncError && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          onClose={() => setSyncError(null)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSyncError(null)}
            severity={alertSeverity}
            sx={{ width: "100%" }}
          >
            {syncError}
          </Alert>
        </Snackbar>
      )}
      <div className="p-4">
        <TailwindFilterHeader
          title="AWS Groups"
          isIconNeeded={true}
          subtitle={"Manage cloud groups and permissions"}
          dropdowns={[
            {
              label: "Tenant",
              value: selectedTenantName,
              options: tenantList.map((t) => ({
                label: t.tenantName,
                value: t.tenantName,
              })),
              onChange: handleTenantChange,
            },
            {
              label: "Accounts",
              value: awsAccountId,
              options: accounts.map((t) => ({
                label: t?.label,
                value: t?.value,
              })),
              onChange: handleAccountChange,
            },
          ]}
          tabs={[]}
          isSyncing={syncStatus["aws"]}
          onSync={ondemandButton}
          extraActions={
            <button
              onClick={handleDeleteMembership}
              disabled={selectedUsers.length === 0}
              className={`px-5 py-3 rounded-xl font-medium text-white ${
                selectedUsers.length === 0
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-red-600 hover:bg-red-700 shadow-md"
              }`}
            >
              Delete Membership
            </button>
          }
          isSyncNeeded={awsConfig ? true : false}
        />

        <div className="grid w-full grid-cols-3 gap-2">
          <div className="col-span-1">
            <TailwindTable
              columns={["Group Name"]}
              data={filteredGroups}
              renderCell={renderGroupListCell}
              isSelected={(row) => row.arn === selectedGroup?.arn}
              searchFilter={true}
              searchAction={handleSearchChange}
              searchValue={searchTerm}
              needLoading={loading}
            />
          </div>
          {selectedGroup ? (
            <TailwindTable
              columns={["User Name"]}
              data={filteredUsers}
              renderCell={renderUserName}
              isSelected={(row) => selectedUser?.username === row.username}
              searchFilter={true}
              searchAction={handleUsersSearchChange}
              searchValue={searchTerm}
              needLoading={loading}
            />
          ) : null}
          {selectedGroup && selectedUser ? (
            <>
              <TailwindTable
                columns={[` Details for User: ${selectedUser.username}`]}
                data={[selectedUser]}
                renderCell={(user, colIndex, col) =>
                  renderUserDetailsCell(
                    user,
                    colIndex,
                    col,
                    tabValue,
                    setTabValue,
                    selectedGroup,
                  )
                }
                needLoading={false}
              />
            </>
          ) : null}
        </div>
      </div>
      <PolicyDetailsModal
        open={policiesDetailsModalOpen}
        onClose={() => setPoliciesDetailsModalOpen(false)}
        policiesDetails={policiesDetails}
      />
    </>
  );
};

export default AWSGroups;
